import { Team, TeamInvite } from '@demind-inc/core';
import { useMutation } from '@tanstack/react-query';

import { teamApi } from '../api';

export interface ResolveTeamInviteResult {
  invite: TeamInvite;
  team: Pick<Team, 'teamId' | 'name' | 'status'>;
  viewer: {
    userId?: string;
    email?: string;
    isEligible?: boolean;
    reason?: string;
  };
}

export const useResolveTeamInvite = () => {
  const resolveTeamInviteMutation = useMutation({
    mutationFn: (inviteCode: string) => {
      return teamApi.getTeamInvite(inviteCode).then(({ data }) => {
        return {
          invite: data.invite as TeamInvite,
          team: data.team as Pick<Team, 'teamId' | 'name' | 'status'>,
          viewer: data.viewer as ResolveTeamInviteResult['viewer'],
        } as ResolveTeamInviteResult;
      });
    },
  });

  return {
    resolveTeamInvite: resolveTeamInviteMutation.mutateAsync,
    isResolvingTeamInvite: resolveTeamInviteMutation.isPending,
    ...resolveTeamInviteMutation,
  };
};
